import { render, staticRenderFns } from "./LazyDocuments.vue?vue&type=template&id=04e71d7a"
import script from "./LazyDocuments.vue?vue&type=script&lang=js"
export * from "./LazyDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports